import { render, staticRenderFns } from "./home-search.vue?vue&type=template&id=6d2c31cd&scoped=true"
import script from "./home-search.vue?vue&type=script&lang=js"
export * from "./home-search.vue?vue&type=script&lang=js"
import style0 from "./home-search.vue?vue&type=style&index=0&id=6d2c31cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c31cd",
  null
  
)

export default component.exports